<template>
  <div id="app">
    <NavMenu />
    <small style="padding: 1rem 1rem 0; display: block; font-size: 0.75em; color: gray; pointer-events: none; text-align: right;">HEY MAN YOU SHOULD TRY THE ADMIN UI IN THE PANEL</small>
    <div class="content">
      <router-view v-if="loggedIn"></router-view>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import NavMenu from './components/NavMenu.vue'

export default {
  name: 'app',
  components: {
    NavMenu
  },
  computed: {
    ...mapGetters(['loggedIn']),
    ...mapState(['account'])
  }
}
</script>

<style>
*, ::before, ::after {
  box-sizing: border-box;
}

body {
  margin: 0;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-weight: 200;
}

.content {
  padding: 1em;
}

.pane {
  border: 1px solid #999;
  border-radius: 2px;
}

.emoji {
  font-family:
    'apple color emoji',
    'segoe ui emoji',
    'noto color emoji',
    'android emoji',
    'emojisymbols',
    'emojione mozilla',
    'twemoji mozilla',
    'segoe ui symbol';
}

.icon.emoji.active::before { content: '\2B50'; }
.icon.emoji.approved::before { content: '\2714'; }
.icon.emoji.pending::before { content: '\23F1'; }
.icon.emoji.archived::before { content: '\1F512'; }
.icon.emoji.plus::before { content: '\2795'; }
.icon.emoji.times::before { content: '\274C'; }

.role {
  display: inline-block;
  padding: 0.1em 0.25em;
  border-radius: 2px;
  font-size: smaller;
  background-color: gainsboro;
  font-family: monospace;
  text-transform: uppercase;
  vertical-align: middle;
  padding: 0 1em 0 0;
  margin-right: 0.25em;
}
.role .icon {
  width: 2em;
  height: 2em;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.25);
  color: white;
  font-size: smaller;
  border-radius: 2px 0 0 2px;
}
.role.admin { background-color: gold; color: darkgoldenrod; }
.role.banned { background-color: firebrick; color: mistyrose; }
.role.trusted { background-color: skyblue; color: royalblue; }

code {
  margin: 1px;
  padding: 2px 4px;
  background-color: #fee;
  color: deeppink;
  text-transform: uppercase;
  display: inline-block;
  font-size: 10px;
}

input[type="text"],
input[type="number"],
textarea,
select {
  padding: 0.5em;
  font-family: inherit;
}
</style>
